import Translator from "./Translator";

export default function TranslatorIndex() {
    return (
        <>
            <Translator />
        </>
    )
}